var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"layoutCtlDiv",staticClass:"h100b",class:_vm.getLayoutClass},[_c('div',{staticClass:"goLayout",style:(_vm.goLayoutStyle),attrs:{"id":_vm.layoutId,"async":"async"}},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./goingsrc/vueCom/layoutVue/go-layout.vue